module.exports = __webpack_public_path__ + "static/media/hostucan.bb49e955.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/hostucan.png
// module id = 115
// module chunks = 0